/* Japonija.lt theme behaviors — plain vanilla JS, no dependencies */
(function () {
  'use strict';

  /* -------------------------------------------------- */
  /* Utilities                                          */
  /* -------------------------------------------------- */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const on = (el, evt, fn, opts) => el && el.addEventListener(evt, fn, opts);

  const rootDoc = document.documentElement;
  const body = document.body;

  /* -------------------------------------------------- */
  /* Sticky header scroll state                         */
  /* -------------------------------------------------- */
  const header = $('.site-header');
  if (header) {
    const setScrolled = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
      rootDoc.style.setProperty('--header-h', header.offsetHeight + 'px');
    };
    setScrolled();
    on(window, 'scroll', setScrolled, { passive: true });
    on(window, 'resize', setScrolled);
  }

  /* -------------------------------------------------- */
  /* Reveal on scroll                                   */
  /* -------------------------------------------------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    $$('.reveal').forEach((el) => io.observe(el));
  } else {
    $$('.reveal').forEach((el) => el.classList.add('is-visible'));
  }

  /* -------------------------------------------------- */
  /* Mobile navigation drawer                           */
  /*                                                    */
  /* Lifted to <body> on init so no ancestor stacking   */
  /* context (e.g. header's backdrop-filter) can clip   */
  /* the fixed drawer. Click handlers use delegation    */
  /* on document so they survive any re-render.         */
  /* -------------------------------------------------- */
  const mobileNav = $('[data-mobile-nav]');
  let mobileNavBackdrop = null;

  if (mobileNav) {
    if (mobileNav.parentElement !== body) body.appendChild(mobileNav);
    mobileNavBackdrop = document.createElement('div');
    mobileNavBackdrop.className = 'mobile-nav-backdrop';
    mobileNavBackdrop.setAttribute('data-mobile-nav-backdrop', '');
    mobileNavBackdrop.setAttribute('aria-hidden', 'true');
    body.appendChild(mobileNavBackdrop);
  }

  const openMobile = () => {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (mobileNavBackdrop) mobileNavBackdrop.classList.add('is-open');
    body.style.overflow = 'hidden';
    const opener = $('[data-mobile-nav-open]');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    const first = $('button, a', mobileNav);
    if (first) first.focus();
  };
  const closeMobile = () => {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (mobileNavBackdrop) mobileNavBackdrop.classList.remove('is-open');
    body.style.overflow = '';
    const opener = $('[data-mobile-nav-open]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    }
  };

  on(document, 'click', (e) => {
    if (e.target.closest('[data-mobile-nav-open]')) { e.preventDefault(); openMobile(); return; }
    if (e.target.closest('[data-mobile-nav-close]')) { e.preventDefault(); closeMobile(); return; }
    if (e.target.closest('[data-mobile-nav-backdrop]')) { closeMobile(); return; }
    if (e.target.closest('[data-mobile-nav] a')) { closeMobile(); }
  });
  /* -------------------------------------------------- */
  /* Inline search panel                                 */
  /* -------------------------------------------------- */
  const searchPanel = $('[data-search-panel]');
  const searchInput = searchPanel && $('input[type="search"]', searchPanel);
  function openSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = false;
    $$('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    if (searchInput) { searchInput.focus(); searchInput.select(); }
  }
  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = true;
    $$('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  }
  on(document, 'click', (e) => {
    if (e.target.closest('[data-search-toggle]')) {
      e.preventDefault();
      // If the toggle was clicked inside the mobile drawer, close drawer first
      // so the search panel (which lives in the sticky header) isn't covered.
      if (e.target.closest('[data-mobile-nav]')) closeMobile();
      if (searchPanel && searchPanel.hidden) openSearch(); else closeSearch();
    } else if (e.target.closest('[data-search-close]')) {
      e.preventDefault();
      closeSearch();
    }
  });

  on(document, 'keydown', (e) => { if (e.key === 'Escape') { closeMobile(); closeCart(); closeSearch(); } });

  /* -------------------------------------------------- */
  /* Cart drawer                                         */
  /* -------------------------------------------------- */
  const cartDrawer = $('[data-cart-drawer]');
  const cartOverlay = $('[data-cart-overlay]');
  const openCartTriggers = $$('[data-cart-open]');
  const closeCartTriggers = $$('[data-cart-close]');

  function openCart(e) {
    if (e) e.preventDefault();
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    body.style.overflow = '';
  }
  openCartTriggers.forEach((el) => on(el, 'click', openCart));
  closeCartTriggers.forEach((el) => on(el, 'click', closeCart));
  on(cartOverlay, 'click', closeCart);

  /* Add to cart (AJAX) */
  $$('form.product-form').forEach((form) => {
    on(form, 'submit', async (e) => {
      const btn = form.querySelector('[type="submit"]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = '…';
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('add failed');
        await refreshCart();
        openCart();
      } catch (err) {
        btn.textContent = 'Klaida, bandykite dar kartą';
        setTimeout(() => { btn.textContent = originalText; }, 2200);
      } finally {
        setTimeout(() => { btn.disabled = false; if (btn.textContent === '…') btn.textContent = originalText; }, 400);
      }
    });
  });

  async function refreshCart() {
    try {
      const [jsonRes, sectionRes] = await Promise.all([
        fetch('/cart.js').then((r) => r.json()),
        fetch('/?section_id=cart-drawer').then((r) => r.text()).catch(() => null),
      ]);
      updateCartCount(jsonRes.item_count);
      if (sectionRes && cartDrawer) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionRes, 'text/html');
        const newBody = doc.querySelector('[data-cart-drawer-body]');
        const drawerBody = $('[data-cart-drawer-body]', cartDrawer);
        if (newBody && drawerBody) drawerBody.innerHTML = newBody.innerHTML;
        const newFoot = doc.querySelector('[data-cart-drawer-foot]');
        const drawerFoot = $('[data-cart-drawer-foot]', cartDrawer);
        if (newFoot && drawerFoot) drawerFoot.innerHTML = newFoot.innerHTML;
        bindCartLineControls();
      }
    } catch (err) { /* silent */ }
  }

  function updateCartCount(n) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
  }

  function bindCartLineControls() {
    $$('[data-cart-change]').forEach((btn) => {
      on(btn, 'click', async (e) => {
        e.preventDefault();
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
        refreshCart();
      });
    });
  }
  bindCartLineControls();

  /* -------------------------------------------------- */
  /* Product gallery                                    */
  /* -------------------------------------------------- */
  $$('[data-product-gallery]').forEach((gallery) => {
    const main = $('[data-gallery-main]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach((thumb) => {
      on(thumb, 'click', () => {
        if (!main) return;
        const src = thumb.dataset.full || (thumb.querySelector('img') && thumb.querySelector('img').src);
        const alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
        if (!src) return;
        const img = main.querySelector('img');
        if (img) { img.src = src; img.alt = alt; }
        $$('[data-gallery-thumb]', gallery).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  /* -------------------------------------------------- */
  /* Quantity steppers                                  */
  /* -------------------------------------------------- */
  $$('[data-qty]').forEach((group) => {
    const input = $('input', group);
    const dec = $('[data-qty-dec]', group);
    const inc = $('[data-qty-inc]', group);
    if (!input) return;
    on(dec, 'click', () => { input.value = Math.max(1, parseInt(input.value || '1', 10) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
    on(inc, 'click', () => { input.value = Math.max(1, parseInt(input.value || '1', 10) + 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
  });

  /* -------------------------------------------------- */
  /* Collection sort (reload with ?sort_by=)             */
  /* -------------------------------------------------- */
  $$('[data-collection-sort]').forEach((sel) => {
    on(sel, 'change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* -------------------------------------------------- */
  /* Article share — Instagram: native share sheet on   */
  /* mobile, clipboard copy on desktop                  */
  /* -------------------------------------------------- */
  $$('[data-share]').forEach((root) => {
    const url = root.dataset.shareUrl;
    const title = root.dataset.shareTitle || '';
    const toast = $('[data-share-toast]', root);
    const igBtn = $('[data-share-instagram]', root);
    if (!igBtn) return;
    on(igBtn, 'click', async (e) => {
      e.preventDefault();
      if (navigator.share) {
        try { await navigator.share({ title, url }); return; } catch (_) { /* fall through */ }
      }
      try {
        await navigator.clipboard.writeText(url);
      } catch (_) {
        const ta = document.createElement('textarea');
        ta.value = url; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (_) {}
        ta.remove();
      }
      if (toast) {
        toast.hidden = false;
        clearTimeout(igBtn._t);
        igBtn._t = setTimeout(() => { toast.hidden = true; }, 2400);
      }
    });
  });

  /* -------------------------------------------------- */
  /* Footer year                                        */
  /* -------------------------------------------------- */
  $$('[data-current-year]').forEach((el) => { el.textContent = new Date().getFullYear(); });
})();
